

























































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment";
import { CustomerFeedback } from "@/http/api/v2/customerFeedback";
import { CustomerFeedbackDto } from "@/http/dto/customerFeedback";
import { fileUrl } from "@/constants";
const HotelModule = namespace("HotelModule");

@Component
export default class MyFeedback extends Vue {
  @HotelModule.State("hotelObjectId") hotelObjectId!: string;
  @HotelModule.State("hotelInfo") hotelInfo!: any;
  items: CustomerFeedbackDto[] = [];
  selected: CustomerFeedbackDto | null = null;
  loading = false;
  replying = false;
  reply = "";
  page = 1;
  take = 20;
  total = 0;

  get currentHotelObjectId() {
    return this.hotelInfo?.objectId || this.hotelObjectId || "";
  }

  @Watch("currentHotelObjectId")
  currentHotelObjectIdChanged(value: string) {
    if (value) this.load();
  }

  async mounted() {
    await this.load();
    const objectId = this.$route.query.feedback as string;
    const item = this.items.find(value => value.objectId === objectId);
    if (item) await this.open(item);
  }

  async load() {
    if (!this.currentHotelObjectId) return;
    this.loading = true;
    try {
      const result = await CustomerFeedback.list(this.currentHotelObjectId, this.page, this.take);
      this.items = result.items;
      this.total = result.total;
    } catch { this.$message.error("의견 내역을 불러오지 못했습니다."); }
    finally { this.loading = false; }
  }

  async open(item: CustomerFeedbackDto) {
    try {
      this.selected = await CustomerFeedback.detail(this.currentHotelObjectId, item.objectId);
      item.hasUnreadReply = false;
    } catch { this.$message.error("의견을 불러오지 못했습니다."); }
  }

  async sendMessage() {
    if (!this.selected || !this.reply.trim()) return;
    this.replying = true;
    try {
      this.selected = await CustomerFeedback.addMessage(this.currentHotelObjectId, this.selected.objectId, this.reply.trim());
      this.reply = "";
      this.$message.success("추가 내용이 전달되었습니다.");
      await this.load();
    } catch { this.$message.error("추가 내용을 보내지 못했습니다."); }
    finally { this.replying = false; }
  }

  changePage(page: number) { this.page = page; this.load(); }
  dateTime(value: string) { return moment(value).format("YYYY.MM.DD HH:mm"); }
  fileUrl(value: string) { return fileUrl(value); }
  typeText(value: string) { return ({ inconvenience: "불편사항", error: "오류 신고", idea: "아이디어", other: "기타" } as any)[value] || value; }
  statusText(value: string) { return ({ received: "접수", reviewing: "검토 중", planned: "반영 예정", answered: "답변 완료" } as any)[value] || value; }
  statusColor(value: string) { return ({ received: "blue", reviewing: "orange", planned: "purple", answered: "green" } as any)[value] || "default"; }
}
